import React, { ChangeEvent, useState } from 'react'
import {
  Flex,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverArrow,
  PopoverCloseButton,
  PopoverBody,
  PopoverFooter,
  Button,
  Textarea,
  Text,
} from '@chakra-ui/react'

import { FormItem } from 'components'
import { Pencil } from 'components/icons'
import { MessageCenterMessage, MessageCenterRoutes } from 'components/tools/MessageCenterChat/types'
import { useMessageCenterChatManager } from 'components/tools/MessageCenterChat/contexts/MessageCenterChatManager/Provider'
import { MessageCenterMessageCardActionsProps } from '../..'

type Props = MessageCenterMessageCardActionsProps & {
  routes: MessageCenterRoutes
}

export default function MessageCenterUpdateMessage({ message, setMenuPosition, routes }: Props) {
  const [loadingUpdateMessage, setLoadingUpdateMessage] = useState<boolean>(false)
  const [newMessageText, setNewMessageText] = useState<string>(message.message || '')

  const { messages, setMessages } = useMessageCenterChatManager()

  function handleOnTextareaChange(event: ChangeEvent<HTMLTextAreaElement>) {
    const value = event.target.value
    setNewMessageText(value)
  }

  async function handleUpdateMessage() {
    setLoadingUpdateMessage(true)
    const response = await routes.updateMessage({ ...message, message: newMessageText })
    if (response?.header?.success) {
      const newMessage = response?.body?.case_chat_message as MessageCenterMessage
      const updatedMessages = messages.map((messageItem) => {
        if (messageItem.id === newMessage.id) return newMessage
        return messageItem
      })
      setMenuPosition(null)
      setMessages(updatedMessages)
    }
    setLoadingUpdateMessage(false)
  }

  return (
    <Popover>
      {({ onClose }) => (
        <>
          <PopoverTrigger>
            <Flex align="center" p={2} gap={2} className="accessible" _hover={{ bg: 'primary', color: 'light' }}>
              <Pencil />
              <Text>Editar</Text>
            </Flex>
          </PopoverTrigger>
          <PopoverContent>
            <PopoverHeader color="dark">Atualizando mensagem</PopoverHeader>
            <PopoverArrow />
            <PopoverCloseButton bg="primary" />
            <PopoverBody color="dark">
              <FormItem label="Nova mensagem">
                <Textarea value={newMessageText} onChange={handleOnTextareaChange} />
              </FormItem>
            </PopoverBody>
            <PopoverFooter>
              <Flex align="center" gap={2}>
                <Button variant="outline" minWidth="50%" onClick={onClose}>
                  Fechar
                </Button>
                <Button
                  isLoading={loadingUpdateMessage}
                  minWidth="50%"
                  onClick={async () => {
                    await handleUpdateMessage()
                    onClose()
                  }}
                >
                  Atualizar
                </Button>
              </Flex>
            </PopoverFooter>
          </PopoverContent>
        </>
      )}
    </Popover>
  )
}
